import { Box, Button, Typography, IconButton, Divider, Checkbox, Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import cornerRing from '../../../commom/Assets/images/CornerRing.png';
import boosterReminder from '../../../commom/Assets/images/booster-reminder.png';

type Props = {
  open: boolean;
  onClose: () => void;
  dontRemind30Days: boolean;
  setDontRemind30Days: (v: boolean) => void;
  handleNo: () => Promise<void> | void;
  handleYes: () => void;
//   handleLearnMore: () => void;
};

export default function BoosterLoanReminderModal({ open, onClose, dontRemind30Days, setDontRemind30Days, handleNo, handleYes, handleLearnMore }: Props) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: '#141414',
        boxShadow: '0 8px 32px 0 rgba(34, 34, 34, 0.37)',
        p: { xs: 3, sm: 6 },
        borderRadius: 4,
        minWidth: { xs: 320, sm: 450 },
        maxWidth: '90vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        border: '1px solid rgba(255,255,255,0.12)',
        overflow: 'hidden',
      }}>
        <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 12, top: 12, color: 'rgba(255,255,255,0.7)' }}>
          <CloseIcon />
        </IconButton>
        <Box component="img" src={cornerRing} alt="decorative ring" sx={{ position: 'absolute', right: -40, bottom: -30, width: 220, opacity: 0.35, pointerEvents: 'none' }} />
        <Box component="img" src={boosterReminder} alt="Booster Loan" sx={{ width: '100%', maxWidth: 360, mb: 2, borderRadius: 2 }} />
        <Typography variant="h5" mb={2} sx={{ color: '#fff', fontWeight: 700, textAlign: 'center' }}>Unlock More with a Booster Loan!</Typography>
        <Typography mb={3} sx={{ color: '#fff', fontSize: '16px', textAlign: 'center', fontWeight: 400, lineHeight: 1.6 }}>Boost your purchasing power - increase your order limit upto 2x instantly by activating a Booster Loan.</Typography>

        <Box display="flex" alignItems="center" mb={3} width="100%">
          <Checkbox checked={dontRemind30Days} onChange={(e) => setDontRemind30Days(e.target.checked)} sx={{ p: 0, mr: 1, color: '#4A7AF2', '&.Mui-checked': { color: '#4A7AF2' }, '& .MuiSvgIcon-root': { fontSize: 22 } }} />
          <Typography sx={{ color: '#fff', fontSize: '14px', mt: '2px' }}>Don’t remind me about the Booster Loan for the next 30 days. (Checkout)</Typography>
        </Box>
        <Divider sx={{ width: '100%', borderColor: 'rgba(255,255,255,0.12)', mb: 2 }} />
        <Box display="flex" gap={2} width="100%" justifyContent="center">
          <Button variant="outlined" onClick={handleNo} sx={{ minWidth: 160, borderRadius: '28px', fontWeight: 500, fontSize: '16px', borderColor: '#f2674a', color: '#f2674a', textTransform: 'none', px: 2 }}>Continue without Loan</Button>
          <Button variant="contained" onClick={handleYes} sx={{ minWidth: 220, borderRadius: '28px', fontWeight: 500, fontSize: '16px', background: 'linear-gradient(90deg, #f2674a 0%, #ffbf00 100%)', color: '#fff', textTransform: 'none' }}>Buy Now with Booster Loan</Button>
        </Box>
        {/* <Box mt={2}>
          <Button variant="text" onClick={handleLearnMore} sx={{ color: '#f2674a', mt: 1 }}>Learn more</Button>
        </Box> */}
      </Box>
    </Modal>
  );
}
